import React, { createContext, useState } from "react";

import { useNavigate, useLocation } from "react-router";
import RoutConstants from "../../../constants/routeConstants.json";
export const StabilizerUserDeviceListPageContext = createContext({});
export const StabilizerUserDeviceListPageContextProvider = ({ children }) => {
  const [count, setCount] = useState(8);
  const [isLoading, setIsLoading] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const deviceList = location?.state?.result;
  const catogoryId = localStorage.getItem("dashboard_Id");
  const navigateToDeviceDashboard = (modelName) => {

      navigate({
        pathname: RoutConstants.STABILIZER_DEVICE_DATA,
        search: "?stabilizer=singleStabilizer",
      });
   
   
 
    localStorage.setItem("model", modelName);
  };
   
  const providerValue = {
    count,
    deviceList,
    navigateToDeviceDashboard,

  };
  return (
    <StabilizerUserDeviceListPageContext.Provider value={providerValue}>
      {children}
    </StabilizerUserDeviceListPageContext.Provider>
  );
};
